/* ============================================================
   ROOTINE v2 — Page transitions: naming the product image
   base.css turns on cross-document View Transitions for every navigation and
   styles the `product` group. This file decides which image, if any, is
   `product` on the page being left and on the page arriving, so the bottle a
   visitor clicks on the wall (or in the dial) becomes the bottle on the product
   page, and comes back to its plate on the way out. The product page names its
   own lit view in CSS; here we name plates, which only know at the last moment.

   Rules: one element with the name at a time (two would cancel the transition);
   only a product image gets it — a nav link to /products/... does not; and every
   name set here is cleared once the transition has run, so nothing stale is
   carried into the next one.
   ============================================================ */
(function () {
  if (!('CSS' in window) || !CSS.supports || !CSS.supports('view-transition-name: x')) return;
  var NAME = 'product';
  var last = null;   // the link most recently clicked — the plate whose image should travel

  function path(u) { try { return new URL(u, location.href).pathname.replace(/\/+$/, ''); } catch (e) { return ''; } }
  function clear() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vt]'), function (el) { el.style.viewTransitionName = ''; el.removeAttribute('data-vt'); });
  }
  function name(el) { if (!el) return; clear(); el.style.viewTransitionName = NAME; el.setAttribute('data-vt', ''); }
  /* the image that stands for a product on this page: inside a link to it, and a plate rather than a nav
     item — the wall's plate first, then anything else that carries a picture (the dial's bottle, a pair) */
  function imageFor(p) {
    var links = document.querySelectorAll('a[href]'), fallback = null;
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (path(a.getAttribute('href')) !== p) continue;
      var im = a.querySelector('img'); if (!im) continue;
      if (a.classList.contains('plate')) return im;
      if (!fallback && a.closest('.dial__shot, .pair, .cart-item, .pl, .vc')) fallback = im;
    }
    return fallback;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) last = a;
  }, true);

  /* leaving: name the image of the product we are going to, if this page shows one */
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition || !e.activation || !e.activation.entry) return;
    var p = path(e.activation.entry.url), im = null;
    if (p.indexOf('/products/') === -1) { clear(); return; }
    if (last && path(last.getAttribute('href')) === p) im = last.querySelector('img');
    if (im && !im.closest('.plate, .dial__shot, .pair, .cart-item')) im = null;   // a title link in the nav is not a plate
    if (!im) im = imageFor(p);
    if (im) name(im); else clear();
  });

  /* arriving: if we came from a product page and this page shows that product, name its plate so the
     bottle comes back to it. The product page names its own view in CSS and needs nothing from here. */
  window.addEventListener('pagereveal', function (e) {
    clear();   // never trust a name left behind (bfcache restores the page as it was)
    if (!e.viewTransition) return;
    if (document.querySelector('.pdp__slide.is-on > img')) return;
    var from = (window.navigation && navigation.activation && navigation.activation.from) ? navigation.activation.from.url : document.referrer;
    var p = path(from);
    if (!p || p.indexOf('/products/') === -1) return;
    var im = imageFor(p);
    if (!im) return;
    name(im);
    e.viewTransition.finished.then(clear, clear);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) clear(); });
})();
